/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Range_InvalidInputs */

const en_shopping_range_invalid = /** @type {(inputs: Shopping_Range_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The end is before the start.`)
};

const de_shopping_range_invalid = /** @type {(inputs: Shopping_Range_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ende liegt vor dem Anfang.`)
};

/**
* | output |
* | --- |
* | "The end is before the start." |
*
* @param {Shopping_Range_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_range_invalid = /** @type {((inputs?: Shopping_Range_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Range_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_range_invalid(inputs)
	return en_shopping_range_invalid(inputs)
});